import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

// Fix default Leaflet marker icon paths (webpack messes them up)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

// Custom olive-colored marker
const oliveIcon = L.divIcon({
  className: "olivara-marker",
  html: `
    <div style="
      width: 36px; height: 36px;
      background: #4A5D23;
      border: 3px solid #F9F6F0;
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      box-shadow: 0 4px 12px rgba(44,42,41,0.25);
      display: flex; align-items: center; justify-content: center;
    ">
      <div style="
        width: 10px; height: 10px;
        background: #F9F6F0;
        border-radius: 50%;
        transform: rotate(45deg);
      "></div>
    </div>
  `,
  iconSize: [36, 36],
  iconAnchor: [18, 36],
  popupAnchor: [0, -36],
});

const CROATIA_CENTER = [43.8, 16.0];

export const ProducersMap = ({ vendors, center, zoom = 7, height = "520px", interactive = true }) => {
  const withCoords = vendors.filter((v) => typeof v.lat === "number" && typeof v.lng === "number");
  if (withCoords.length === 0) {
    return (
      <div className="bg-boneAlt rounded-sm flex items-center justify-center text-ink-muted text-sm" style={{ height }}>
        Map will appear once producers add their location.
      </div>
    );
  }
  const mapCenter = center || (withCoords.length === 1 ? [withCoords[0].lat, withCoords[0].lng] : CROATIA_CENTER);
  return (
    <div
      className="rounded-sm overflow-hidden hairline relative"
      style={{ height }}
      data-testid="producers-map"
    >
      <MapContainer
        center={mapCenter}
        zoom={zoom}
        scrollWheelZoom={interactive}
        dragging={interactive}
        doubleClickZoom={interactive}
        zoomControl={interactive}
        style={{ height: "100%", width: "100%", background: "#F3EFE6" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {withCoords.map((v) => (
          <Marker key={v.vendor_id} position={[v.lat, v.lng]} icon={oliveIcon}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                <p style={{ fontSize: 10, letterSpacing: "0.15em", textTransform: "uppercase", color: "#5C5855", margin: 0 }}>
                  {v.region}
                </p>
                <p style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: 20, margin: "4px 0 8px", color: "#2C2A29" }}>
                  {v.farm_name}
                </p>
                <Link
                  to={`/vendor/${v.vendor_id}`}
                  style={{ fontSize: 12, color: "#4A5D23", textDecoration: "underline" }}
                  data-testid={`map-popup-link-${v.vendor_id}`}
                >
                  Visit storefront →
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
